/* Carlow & Friends priority processing for Shrine cart drawer (draft) */
(function () {
  if (window.CarlowPriorityDrawerInitialized) return;
  window.CarlowPriorityDrawerInitialized = true;
  const PRIORITY_ID = 67792935452892;

  function setPending(checkbox, status, pending) {
    checkbox.disabled = pending;
    const checkout = document.getElementById('CartDrawer-Checkout');
    if (checkout) checkout.disabled = pending;
    if (status && pending) {
      status.hidden = false;
      status.textContent = 'Updating your cart…';
    }
  }

  async function sendJson(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Cart update failed (' + response.status + ')');
    return response.json();
  }

  async function refreshDrawer(root) {
    const response = await fetch(root + '?sections=cart-drawer,cart-icon-bubble', {
      credentials:'same-origin',
      cache:'no-store',
      headers:{'Accept':'application/json'}
    });
    if (!response.ok) throw new Error('Cart display did not refresh');
    const sections = await response.json();
    if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) {
      throw new Error('Cart display sections unavailable');
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      throw new Error('Cart drawer display unavailable');
    }
    drawer.renderContents({sections});
  }

  document.addEventListener('change', async function(event) {
    const box = event.target;
    if (!box || !box.matches || !box.matches('[data-carlow-priority-toggle]')) return;
    const wrapper = box.closest('.carlow-priority-processing-drawer');
    if (!wrapper) return;
    const status = wrapper.querySelector('[data-carlow-priority-status]');
    const wanted = box.checked;
    const root = wrapper.getAttribute('data-carlow-priority-root') || '/';

    setPending(box, status, true);
    try {
      const res = await fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store'});
      if (!res.ok) throw new Error('Unable to retrieve cart');
      const cart = await res.json();
      const lines = cart.items.filter(item => Number(item.variant_id) === PRIORITY_ID);

      if (wanted && lines.length === 0) {
        await sendJson(root + 'cart/add.js', {items:[{id:PRIORITY_ID, quantity:1}]});
      } else if (!wanted) {
        for (const line of lines) {
          await sendJson(root + 'cart/change.js', {id:line.key, quantity:0});
        }
      } else if (wanted && lines.length > 0 && lines[0].quantity !== 1) {
        await sendJson(root + 'cart/change.js', {id:lines[0].key, quantity:1});
      }

      try {
        await refreshDrawer(root);
      } catch (refreshError) {
        console.warn('Drawer refresh fallback:',refreshError);
        window.location.reload();
      }
    } catch (err) {
      console.error('Priority order processing could not be updated:',err);
      box.checked = !wanted;
      if (status) {
        status.hidden = false;
        status.textContent = 'Could not update. Please try again.';
      }
      setPending(box, status, false);
    }
  });
})();